import * as React from 'react';

const CardReaderSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.8 15H3.2L4.9 3h14.3l1.6 12zM13 19h-2v-3h2v3zm0 2h-2v-1h2v1zm1 1v-6h8L20 2H4L2 16h8v6h4z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.3 6h9.4l.6 4h1l-.7-5H6.4l-.7 5h1z"
        />
    </svg>
);

CardReaderSvg.displayName = 'CardReaderSvg';
export default CardReaderSvg;
